import { Group, Select } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { RuleParameters } from 'models/rules';
import { useTranslation } from 'react-i18next';
import { displayFormError } from 'utils/validation';
import { TimeWindowField } from './TimeWindowField';
import { showUsaFeature } from '../../../../../utils/app';

export const PhysiologicalParameterMissingFields = () => {
  const { t } = useTranslation();
  const { getInputProps, values, errors } = useCreateRuleFormContext();

  const dataField = 'data.physiologicalParameterMissing';
  const fieldList = [
    { label: t('weight_label'), value: RuleParameters.weight, enabled: !showUsaFeature },
    { label: t('blood_pressure_label'), value: RuleParameters.diastolicBloodPressure, enabled: !showUsaFeature },
    { label: t('heart_rhythm_label'), value: RuleParameters.heartRate, enabled: true },
  ].filter((f) => f.enabled);

  return (
    <>
      <Group justify={'flex-start'}>
        <Select
          label={t('parameter_label')}
          data={fieldList}
          placeholder={t('select_parameter_label')}
          {...getInputProps(`${dataField}.parameter`)}
          disabled={values.formDisabled}
          error={displayFormError({ errors, dataField: `${dataField}.parameter`, label: t('empty_value_select') })}
        />
      </Group>
      <Group gap={'md'}>
        <TimeWindowField
          dataField={`${dataField}.timeWindow`}
          disabled={!getInputProps(`${dataField}.parameter`).value || values.formDisabled}
        />
      </Group>
    </>
  );
};
